import { createSlice } from "@reduxjs/toolkit";

const initialState: object = {};

const accountSlice = createSlice({
    name: "account",
    initialState,
    reducers: {},
});

export const accountReducer = accountSlice.reducer;

export {
    useGetAuthSettingsQuery,
    useLazyGetAuthSettingsQuery,
    useSetAuthMethodMutation,
    useSendAuthCodeMutation,
} from "../../common/api/account";
